import CardConfiguration, {
  DefaultDateRangeConfiguration,
} from "@app/types/dashboard/CardConfiguration";
import BasePreferences from "@app/types/dashboard/cards/BasePreferences";

export enum DistanceTravelledAggregationType {
  SUM = "SUM",
  AVG = "AVG",
}

export interface DistanceTravelledCriteria {
  aggregationType: DistanceTravelledAggregationType;
}

export default interface DistanceTravelledCardConfiguration extends CardConfiguration<
  DistanceTravelledCriteria,
  DefaultDateRangeConfiguration,
  BasePreferences
> {}
